import store from '@advisor/store';
import {PLATFORM_AREA, COMPONENT_ID, RIA_COMPONENT} from '@advisor/util/constants';
import AdvCommonUtilMethods from '@advisor/util/AdvCommonUtilMethods';

export default [
  {
    // Household Detail
    path: '/advisor/household/:householdId',
    component: () => import('@advisor/components/householdDetails/HouseHoldDetails'),
    name: 'HouseHoldDetail',
    meta: {
      breadCrumbs: {
        to: '/advisor/clients',
        text: 'Clients & Households',
        title: 'Household',
        componentId: COMPONENT_ID.HOUSEHOLD,
      },
      platformArea: PLATFORM_AREA.CLIENTS,
      visibilityComponentId: COMPONENT_ID.CLIENTS,
      riaComponent: RIA_COMPONENT.CLIENTS,
    },
  },
  {
    // Household: Goals Details
    path: '/advisor/household-goal/:householdId/:goalId/:sectionId?/',
    component: () => import('@advisor/components/householdDetails/householdGoals/HouseholdGoals'),
    name: 'HouseholdGoals',
    meta: {
      breadCrumbs: {
        to: '/advisor/clients',
        text: 'Clients & Households',
        title: 'Goal',
        componentId: COMPONENT_ID.GOALS,
      },
      childBreadCrumb: {
        to: '/advisor/household/',
        text: '',
      },
      platformArea: PLATFORM_AREA.CLIENTS,
      visibilityComponentId: COMPONENT_ID.CLIENTS,
      riaComponent: RIA_COMPONENT.CLIENTS,
    },
    beforeEnter: async (to, from, next) => {
      try {
        const res = await store.dispatch('user/getUser');

        const payload = {
          householdId: to.params.householdId,
          riaUserId: res.riaUserId,
        };
        const response = await store.dispatch('household/getHouseHoldInfo', payload);

        // eslint-disable-next-line require-atomic-updates, no-param-reassign
        to.meta.childBreadCrumb.to = `/advisor/household/${to.params.householdId}`;
        // eslint-disable-next-line require-atomic-updates, no-param-reassign
        to.meta.childBreadCrumb.text = `${response.data.houseHoldName}`;
        next();

        return response?.data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
  {
    path: '/advisor/household/:householdId/update',
    name: 'UpdateHousehold',
    component: () => import('@advisor/components/householdDetails/UpdateHousehold'),
    meta: {
      platformArea: PLATFORM_AREA.CLIENTS,
      visibilityComponentId: COMPONENT_ID.CLIENTS,
      riaComponent: RIA_COMPONENT.CLIENTS,
    },
  },
  {
    path: '/advisor/households/create',
    name: 'CreateHousehold',
    component: () => import('@advisor/components/clients/AddHousehold'),
    meta: {
      platformArea: PLATFORM_AREA.CLIENTS,
      visibilityComponentId: COMPONENT_ID.CLIENTS,
      riaComponent: RIA_COMPONENT.CLIENTS,
    },
    beforeEnter: (to, from, next) => AdvCommonUtilMethods.clientViewOnlyCheck(to, from, next),
  },
];
